export default {
    listagem: {
        titulo_pagina: 'Lista de Loincs',
        novo: 'Criar novo Loinc',
        table: {
            empty: 'Nenhum Loinc encontrado',
            nome: 'Nome',
            propriedade: 'Propriedade',
            sistema: 'Sistema',
            ordem_observacao: 'Ordem / Observação',
            nome_longo: 'Nome longo',
            nome_curto: 'Nome curto',
            nome_exibicao: 'Nome de exibição',
            componente: 'Componente',
            tempo: 'Tempo',
            escala: 'Escala',
            metodo: 'Método',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Loinc',
            editar: 'Editar Loinc'
        },
        fields: {
            loinc: {
                label: 'LOINC',
                description: 'Código Loinc do Exame'
            },
            nome_longo: {
                label: 'Nome Longo',
                description: 'Nome longo do Loinc'
            },
            nome_curto: {
                label: 'Nome curto',
                description: 'Nome curto do Loinc'
            },
            nome_exibicao: {
                label: 'Nome de Exibição',
                description: 'Nome de Exibição do Loinc'
            },
            status: {
                label: 'Status',
                description: 'Status do Loinc'
            },
            ordem_obs: {
                label: 'Ordem / Observação',
                description: 'Tipo do Loinc'
            },
            componente: {
                label: 'Componente',
                description: 'Componente do Loinc'
            },
            propriedade: {
                label: 'Propriedade',
                description: 'Propriedade do Loinc'
            },
            tempo: {
                label: 'Tempo',
                description: 'Tempo do Loinc'
            },
            sistema: {
                label: 'Sistema',
                description: 'Sistema do Loinc'
            },
            escala: {
                label: 'Escala',
                description: 'Escala do Loinc'
            },
            metodo: {
                label: 'Método',
                description: 'Método do Loinc'
            },
            botao_salvar : 'Salvar Loinc'
        },
        create: {
            success: 'Loinc criado com Sucesso!',
            error: 'Error ao criar Loinc!'
        },
        update: {
            success: 'Loinc editado com Sucesso!',
            error: 'Error ao editar Loinc!'
        }
    },
    import: {
        csv: {
            titulo_pagina: 'Importar LOINC CSV',
            tabs: {
                arquivo: {
                    label: 'Selecione o arquivo',
                    escolha: 'Escolha um arquivo ou solte um aqui...',
                    solte: 'Solte aqui...',
                    selecionado: 'Arquivo Selecionado',
                    botao_carregar: 'Carregar CSV',
                    carregando: 'Carregando arquivo',
                    preparando: 'Preparando arquivo',
                    enviando: 'Enviando arquivo',
                },
                criados: {
                    label: 'Criados',
                    botao_todos: ''
                },
                atualizados: {
                    label: 'Atualizados',
                    botao_todos: ''
                }
            },
            lang: {
                titulo_pagina: 'Importar Lang LOINC CSV',
            },
            erro: {
                carregar: 'Erro ao carregar CSV',
                processar: 'Erro ao processar CSV',
                enviar: 'Erro ao Enviar parte do CSV'
            }
        }
    }
}
